import React, { Component } from "react";

class CreateSiteListItem extends Component {
  render() {
    let { data, focused, selected, id } = this.props;

    return (
      <div
        className={`side-menu-list-obj ${
          !data.isAlreadySite && "site-candidate"
        } ${focused ? "focused" : ""} ${selected ? "selected" : ""}`}
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        id={id}
        onClick={!data.isAlreadySite && this.props.onTitleClick}
      >
        {/*inner wrapper to generate side color border*/}
        <div className="list-obj-inner-wrapper">
          <div className="obj-title">
            {selected && <i className={"fa fa-check-circle 2x mr-2"} />}
            {data.name}
          </div>
          <div className="obj-data">{data.formatted_address}</div>
        </div>
      </div>
    );
  }
}

export default CreateSiteListItem;
